module.exports = __webpack_public_path__ + "d4c220cae95b9bed6521aefa3b2a2447.svg";